import {
  ensure,
  wrapErrors,
  asAString,
  asAInteger,
  beBetween,
  noLongerThan,
  notEmpty,
  maxWildcards,
} from "../Common/composition";

const validatePriority = wrapErrors(
  (error) => `Priority ${error}`,
  ensure(asAInteger(beBetween(-9999, 9999)))
);

const anyPolicyRateCollisionWith = (__id, policyRate) => (existing) =>
  existing.policyRate === policyRate && existing.__id !== __id;

const POLICY_RATE_MAX_LENGTH = 63;

const validatePolicyRate = wrapErrors(
  (error) => `Policy-Rate ${error}`,
  ensure(
    asAString(notEmpty, noLongerThan(POLICY_RATE_MAX_LENGTH), maxWildcards)
  )
);

const validPolicyRateItems = (item, list) => {
  const { policyRate, stored, __id } = item;
  validatePolicyRate(policyRate);
  if (
    stored !== true &&
    list.find(anyPolicyRateCollisionWith(__id, policyRate)) !== undefined
  ) {
    throw `Policy-Rate "${policyRate}" already present.`;
  }
  return item;
};

const policyRateComposition = {
  cliType: "policy-rate",
  typeLabel: "Policy-Rate",
  viewURL: "viewPolicyRateProfileConfig",
  profileFn: (row)=>{
    return {
      stored: true, 
      pristine: true,
      name: row["NAME"],
      policyRates: row["POLICY-RATE"].map(item=> {
        return {
          policyRate: item["POLICY-RATE"]
        };
      })
    }
  },
  fields: [
    { name: "name", label: "Profile name", type: "text", canUpdate: false, resName: "NAME", numeric: false },
    {
      name: "policyRates",
      cliName: "policy-rate",
      label: "Policy-Rates",
      labelSingle: "Policy-Rate",
      importable: true,
      type: "many",
      validate: validPolicyRateItems,
      canBeEmpty: false,
      resName: "POLICY-RATE",
      numeric: true,
      fields: [
        {
          name: "policyRate",
          label: "Policy-Rate Name",
          type: "text",
          numeric: true,
          wrapSafe: true,
          validate: validatePolicyRate,
          clarify:
            "Enter rate policy name as a string. Wildchar '*' is allowed. Any spaces inside the rate policy name will be replaced by the '_' character.",
        },
      ],
    },
    {
      name: "priority",
      label: "Priority",
      type: "text",
      defaultValue: 9999,
      icon: "label_outline",
      validate: validatePriority,
      resName: "PRIORITY",
      numeric: true,
    },
  ],
};

export default policyRateComposition;
